import { Table } from "dyl-components";
import { useController, useFormContext } from "react-hook-form";
import { useSelector } from "react-redux";
import { Table as SemanticTable } from "semantic-ui-react";
import SelectAllCheckbox from "shared/SelectAllCheckbox";

const OutstandingInvoicesTableHeader = () => {
    const { invoices } = useSelector(state => ({
        invoices: state.subscription.outstanding_invoices
    }));

    const { control } = useFormContext();
    const { field: amountField } = useController({
        control,
        name: "amount",
    });

    return (
        <Table.Row>
            <SemanticTable.HeaderCell width={1}>
                <SelectAllCheckbox
                    count={invoices.length}
                    data={invoices}
                    idProperty={"invoice_id"}
                    type={"Invoices"}
                    onSelectAll={(selectedInvoices) => {
                        amountField.onChange({
                            target: {
                                name: amountField.name,
                                value: selectedInvoices.reduce((total, invoiceId) => {
                                    const invoice = invoices.find(listedInvoice => listedInvoice.invoice_id === invoiceId);
                                    return total + (invoice ? invoice.amount_due : 0);
                                }, 0)
                            }
                        });
                    }}
                />
            </SemanticTable.HeaderCell>
            <SemanticTable.HeaderCell width={3}>
                Invoice ID
            </SemanticTable.HeaderCell>
            <SemanticTable.HeaderCell width={3}>
                Invoice Name
            </SemanticTable.HeaderCell>
            <SemanticTable.HeaderCell width={3}>
                Invoice Status
            </SemanticTable.HeaderCell>
            <SemanticTable.HeaderCell width={3}>
                Invoice Date
            </SemanticTable.HeaderCell>
            <SemanticTable.HeaderCell width={3}>
                Amount Due
            </SemanticTable.HeaderCell>
            <SemanticTable.HeaderCell width={3}>
                Billed
            </SemanticTable.HeaderCell>
        </Table.Row>
    )
}

export default OutstandingInvoicesTableHeader;
